// @documentacao/ui/IconBI.tsx
"use client";

import * as React from "react";

interface IconBIProps {
  /** Tamanho do ícone (número => "px", ou string CSS válida) */
  size?: number | string;
  /** Classes adicionais (ex: "text-black dark:text-white") */
  className?: string;
}

export const IconBI: React.FC<IconBIProps> = ({
  size = 32,
  className = "",
}) => {
  // Se for número ou string numérica, converte para “px”
  const dimension =
    typeof size === "number" || /^\d+$/.test(String(size))
      ? `${size}px`
      : String(size);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={dimension}
      height={dimension}
      className={className}
    >
      <path
        fill="currentColor"
        d="M 7 5 C 4.794 5 3 6.794 3 9 L 3 22 C 3 23.474 3.81 24.749359 5 25.443359 L 5 22 L 5 14 L 5 9 C 5 7.897 5.897 7 7 7 L 25 7 C 26.103 7 27 7.897 27 9 L 27 14 L 27 22 L 27 25.443359 C 28.19 24.749359 29 23.474 29 22 L 29 9 C 29 6.794 27.206 5 25 5 L 7 5 z M 23.5 11 C 22.672 11 22 11.672 22 12.5 L 22 26.5 C 22 27.328 22.672 28 23.5 28 C 24.328 28 25 27.328 25 26.5 L 25 12.5 C 25 11.672 24.328 11 23.5 11 z M 13.5 14 C 12.672 14 12 14.672 12 15.5 L 12 26.5 C 12 27.328 12.672 28 13.5 28 C 14.328 28 15 27.328 15 26.5 L 15 15.5 C 15 14.672 14.328 14 13.5 14 z M 18.5 17 C 17.672 17 17 17.672 17 18.5 L 17 26.5 C 17 27.328 17.672 28 18.5 28 C 19.328 28 20 27.328 20 26.5 L 20 18.5 C 20 17.672 19.328 17 18.5 17 z M 8.5 19 C 7.672 19 7 19.672 7 20.5 L 7 26.5 C 7 27.328 7.672 28 8.5 28 C 9.328 28 10 27.328 10 26.5 L 10 20.5 C 10 19.672 9.328 19 8.5 19 z"
      />
    </svg>
  );
};
